import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import Search from '../views/Search.vue'
import Order from '../views/Order.vue'

Vue.use(VueRouter)

const routes = [
  {
    name: 'index',
    path: '/',
    component: Home
  },
  {
    name: 'search',
    path: '/s/:word',
    component: Search
  },
  /* {
    name: 'orderIndex',
    path: '/order',
    redirect: to => {
      return '/order/index'
    }
  }, */
  {
    name: 'order',
    path: '/order',
    component: Order
  }
]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

export default router



// WEBPACK FOOTER //
// ./src/routers/app.js